const oldPlans = [
	{
		description: 'Mini Cart',
		transactions: 50,
		price: 0,
		real_price: 7.99,
		color: 'teal-500',
		info: 'up to <b>50</b> transactions',
	},
	{
		description: 'Big Cart',
		transactions: 200,
		price: 7,
		real_price: 14.99,
		color: 'blue-500',
		info: 'up to <b>200</b> transactions',
	},
	{
		description: 'Beast Cart',
		transactions: 500,
		price: 15,
		real_price: 29.99,
		color: 'indigo-500',
		info: 'up to <b>500</b> transactions',
	},
	{
		description: 'Ultimate Cart',
		transactions: Infinity,
		price: 20,
		real_price: 49.99,
		color: 'purple-500',
		info: '<b>unlimited</b> transactions',
	},
];

const newPlans = [
	{
		description: 'Mini Cart',
		transactions: 50,
		price: 0,
		real_price: 7.99,
		color: 'teal-500',
		info: 'up to <b>50</b> transactions',
	},
	{
		description: 'Big Cart',
		transactions: 200,
		price: 7,
		real_price: 14.99,
		color: 'blue-500',
		info: 'up to <b>200</b> transactions',
	},
	{
		description: 'Beast Cart',
		transactions: 500,
		price: 15,
		real_price: 29.99,
		color: 'indigo-500',
		info: 'up to <b>500</b> transactions',
	},
	{
		description: 'Ultimate Cart',
		transactions: 1000,
		price: 20,
		real_price: 49.99,
		color: 'purple-500',
		info: '<b>1000</b> transactions',
	},
	{
		description: 'Epic Cart',
		transactions: 2000,
		price: 35,
		real_price: 84.99,
		color: 'purple-500',
		info: '<b>2000</b> transactions',
	},
	{
		description: 'Advanced Cart',
		transactions: 3000,
		price: 15,
		real_price: 99.99,
		color: 'purple-500',
		info: '<b>3000</b> transactions',
	},
	{
		description: 'Monster Cart',
		transactions: Infinity,
		price: 30,
		real_price: 129.99,
		color: 'purple-500',
		info: '<b>unlimited</b> transactions',
	},
];

const newPlansStartsAt = new Date('Thu Mar 04 2021 13:27:29 GMT+0100 (Central European Standard Time)').getTime();
const thirdPlansStartsAt = new Date("Tue Mar 01 2022 13:49:50 GMT+0100 (Central European Standard Time)").getTime();


function getNewPlans (installationTime) {
	const hasSecondPricing = installationTime <= thirdPlansStartsAt;
	return newPlans.map((plan, index) => {
		const currentPlan = { ...plan }
		const isLast = index === (newPlans.length - 1)
		currentPlan.real_price += hasSecondPricing ? isLast ? 0 : 3 : 5
		currentPlan.real_price = Number(currentPlan.real_price.toFixed(2))
		if (!hasSecondPricing) return currentPlan
		if (index === 0) {
			currentPlan.price = 3 // increase the first plan
		}
		if (isLast) {
			currentPlan.price -= 3 // decrease the last one
		}
		return currentPlan
	})
}

export default function getPlans (installationTime) {
	const hasFirstPricing = installationTime <= newPlansStartsAt;
	return hasFirstPricing ? oldPlans : getNewPlans(installationTime);
}

export function getBasePrice (installationTime) {
	const hasFirstPricing = installationTime <= newPlansStartsAt;
	const hasSecondPricing = installationTime <= thirdPlansStartsAt;
	return hasFirstPricing ? 7.99 : hasSecondPricing ? 10.99 : 12.99
}
export function getPlansModal (installationTime) {
	return installationTime <= newPlansStartsAt ? 'chargeApprovalModal.html' : 'chargeApprovalModal2.html';
}
